if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5;
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
      this.autoplayStarted = false;
      this.initSlider();
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 1000,
        navigation: this.showArrows
          ? {
              nextEl: this.querySelector(".m-slider-controls__button-next"),
              prevEl: this.querySelector(".m-slider-controls__button-prev"),
            }
          : false,
        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,
        breakpoints: {
          992: {
            threshold: 2,
          },
        },
        on: {
          init() {
            // PERF: previously dispatched a window "resize" event here, which made
            // every resize listener on the page re-run and forced a full re-layout
            // (shows up as "Forced reflow" / long tasks). Only this slider needs updating.
            requestAnimationFrame(() => this.update());
          },
        },
      });

      this.lastSlide = null;
      this.currentSlide = null;
      this.slider && this.slider.on("init", this.handleChange.bind(this));
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      this.slider.init();

      // PERF: don't rotate slides while the page is loading.
      this.deferAutoplay();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    /**
     * Keeps the first slide on screen until the page has finished loading AND
     * the visitor interacts (scroll / tap / key) or 6 seconds pass after load.
     * Rotating during load makes a later (lazy-loaded) slide the LCP element.
     */
    deferAutoplay() {
      if (!this.autoplay || !this.slider || !this.slider.autoplay) return;

      this.slider.autoplay.stop();

      const events = ["pointerdown", "touchstart", "keydown", "scroll", "wheel"];
      let timer = null;

      const start = () => {
        if (this.autoplayStarted) return;
        this.autoplayStarted = true;
        clearTimeout(timer);
        events.forEach((e) => window.removeEventListener(e, start));
        if (this.slider && !this.slider.destroyed && this.slider.autoplay) {
          this.slider.autoplay.start();
        }
      };

      const arm = () => {
        events.forEach((e) => window.addEventListener(e, start, { once: true, passive: true }));
        timer = setTimeout(start, 6000);
      };

      if (document.readyState === "complete") {
        arm();
      } else {
        window.addEventListener("load", arm, { once: true });
      }
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const slideType = slides[activeIndex] && slides[activeIndex].dataset.slideType;
      this.lastActive && this.slider.slideToLoop(this.lastActive);
      if (slideType === "video_slide") {
        const video = slides[activeIndex] && slides[activeIndex].querySelector("video");

        if (video) {
          let playPromise = video.play();
          this.lastVideo && this.lastVideo.pause();
          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                this.lastVideo = video;
              })
              .catch(() => {});
          }
        }
      } else {
        this.lastVideo && this.lastVideo.pause();
        this.lastVideo = null;
      }
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
// if (!customElements.get("m-slideshow")) {
//   class MSlideshow extends HTMLElement {
//     constructor() {
//       super();
//     }

//     connectedCallback() {
//       this.autoplay = this.dataset.autoplay === "true";
//       this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
//       this.showArrows = this.dataset.enableArrows === "true";
//       this.showDots = this.dataset.enableDots === "true";
//       this.adaptHeight = this.dataset.slideHeight === "adapt";
//       this.id = this.dataset.id;
//       this.sliderContainer = this.querySelector(".swiper-container");

//       this.lastVideo = null;
//       this.lastActive = null;
//       this.timeout = null;
//       this.initSlider();
//     }

//     initSlider() {
//       this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
//         init: false,
//         autoplay: this.autoplay
//           ? {
//               delay: this.autoplaySpeed * 1000,
//               disableOnInteraction: true,
//             }
//           : false,
//         slidesPerView: 1,
//         slidesPerGroup: 1,
//         loop: true,
//         effect: "fade",
//         fadeEffect: {
//           crossFade: true,
//         },
//         speed: 1000,
//         navigation: this.showArrows
//           ? {
//               nextEl: this.querySelector(".m-slider-controls__button-next"),
//               prevEl: this.querySelector(".m-slider-controls__button-prev"),
//             }
//           : false,
//         pagination: this.showDots
//           ? {
//               el: this.querySelector(".swiper-pagination"),
//               clickable: true,
//               bulletClass: "m-dot",
//               bulletActiveClass: "m-dot--active",
//             }
//           : false,
//         breakpoints: {
//           992: {
//             threshold: 2,
//           },
//         },
//         on: {
//           init() {
//             setTimeout(() => {
//               window.dispatchEvent(new Event("resize"));
//             }, 100);
//           },
//         },
//       });

//       this.lastSlide = null;
//       this.currentSlide = null;
//       this.slider && this.slider.on("init", this.handleChange.bind(this));
//       this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
//       this.slider.init();

//       if (Shopify.designMode) {
//         document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
//       }
//     }

//     handleChange(swiper) {
//       const { activeIndex, slides } = swiper;
//       const slideType = slides[activeIndex] && slides[activeIndex].dataset.slideType;
//       this.lastActive && this.slider.slideToLoop(this.lastActive);
//       if (slideType === "video_slide") {
//         const video = slides[activeIndex] && slides[activeIndex].querySelector("video");

//         if (video) {
//           let playPromise = video.play();
//           this.lastVideo && this.lastVideo.pause();
//           if (playPromise !== undefined) {
//             playPromise.then(() => {
//               this.lastVideo = video;
//             });
//           }
//         }
//       } else {
//         this.lastVideo && this.lastVideo.pause();
//         this.lastVideo = null;
//       }
//     }

//     onBlockSelect(ev) {
//       const block = ev.target;
//       const index = Number(block.dataset.slide);
//       this.lastActive = index;
//       if (this.slider) {
//         this.slider.slideToLoop(index);
//       }
//     }
//   }

//   customElements.define("m-slideshow", MSlideshow);
// }
